<template>
  <div class="dialog-container alert-dialog" v-show="visible" @click="hide()">
    <div class="dialog-content" @click.stop="visible=true">
      <div class="dialog-close" @click.stop="hide()"></div>
      <h2><img v-if="image" :src="image"> {{title}}</h2>
      <p v-html="content"></p>
      <div class="alert-buttons" >
        <button v-for="(btn, idxb) in buttons" :key="btn" :class="['alert-button','action-button','small-button',idxb!=0?'action-disabled':null]" @click.stop="button(btn)">{{btn}}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'alert',
  data: function () {
    return {
      visible: false,
      title: null,
      content: null,
      image: null,
      buttons: [],
      callback: null
    }
  },
  mounted: function () {
    this.visible = this.active
  },
  methods: {
    hide: function () {
      this.visible = false
      this.$emit('hide')
      this.button(null)
    },
    button: function (btn) {
      if (btn !== null) {
        this.$emit('click', btn)
      }
      this.visible = false
      if (this.callback) {
        this.callback(btn)
      }
      this.$forceUpdate()
    },
    show: function (title, content, callback, buttons) {
      this.title = title
      this.content = content
      this.visible = true
      this.callback = callback
      if (buttons) {
        this.buttons = buttons
      } else {
        this.buttons = ['Ok']
      }
    }
  },
  props: {
  },
  watch: {
  }
}
</script>

<style scoped lang="scss">
.alert-dialog{
  z-index: 3;
  .dialog-content{
    position: relative;
    width: 500px;
    padding-bottom: 30px !important;
    h2{
      font-weight: normal !important;
    }
  }
  p{
    text-align: center;
  }
}
.share-icons{
  display: flex;
  justify-content: center;
  .share-icon{
    width: 80px;
    height: 80px;
    justify-content: center;
    align-items: center;
    display: flex;
    background-color: #00B5E2;
    border-radius: 4px;
    margin: 20px 20px;
  }
}
.alert-buttons{
  border-top: 2px solid #DCEFFF;
  padding-top: 30px;
  padding-left: 16px !important;
  padding-right: 16px !important;
  margin-top: 30px;
  button {
    margin: 0 8px;
  }
}
@media (max-height: 800px){
  .alert-dialog{
    .dialog-content{
      width: 470px;
    }
  }
}
@media (max-height: 700px){
  .alert-dialog{
    .dialog-content{
      width: 440px;
    }
  }
  .alert-buttons{
    border-top: 2px solid #DCEFFF;
    padding-top: 5vh;
    margin-top: 5vh;
  }
}
</style>
